import { observable } from "mobx";
import { NodeStore } from "./NodeStore";

/**
 * This class represents a video node that displays a video from a given URL.
 * It extends the NodeStore class by adding properties specific to video nodes 
 * while also reusing shared behavior such as positioning and sizing.
 */
export class VideoNodeStore extends NodeStore {

    constructor(initializer: Partial<VideoNodeStore>) {
        super();
        Object.assign(this, initializer);
    }

    @observable
    public title: string | undefined;

    @observable
    public url: string | undefined;

}